
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { SaleConfig } from "@/models/dossier-configs/sale-config";
import { SaleConfig as UserSaleConfig }  from "@/models/user-configs/sale-config";
import { SaleType } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import AppEditDefaultImportSaleRowDescriptionTemplate
	from "@/components/settings-sales/EditDefaultImportSaleRowDescriptionTemplate.vue";
import AppEditPerDocumentStockSettings from "@/components/settings-sales/EditPerDocumentStockSettings.vue";
import AppSaleTypeEditGeneral from "@/components/settings-sales/SaleTypeEditGeneral.vue";
import AppSaleTypeEditTexts from "@/components/settings-sales/SaleTypeEditTexts.vue";
import AppSaleTypeEditMailSettings from "@/components/settings-sales/SaleTypeEditMailSettings.vue";
import AppTranslationEditModal from "@/components/common/TranslationEditModal.vue";
import { CustomTranslation } from "@/utils/custom-translation";
import { UserConfigService } from "@/services/user-config-service";
import AppSaleTypeCalendarSettings from "@/components/settings-sales/SaleTypeCalendarSettings.vue";
import AppSaleTypeCalendarHoverSettings from "@/components/settings-sales/SaleTypeCalendarHoverSettings.vue";
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services";
import { ElectronFunctions } from "@/utils/electron/electron";
import { BrowserInfo } from "@/utils/browser";
import AppSaleTypeEditName from "@/components/settings-sales/SaleTypeEditName.vue";
import { PromisifyModal } from "@/utils/promisify-modal";
import AppAskNextNumber from "@/components/settings-default/ResetNumberingAskForNextNumber.vue";

export default Vue.extend({
	data() {
		return {
			saleType: undefined as SaleType | undefined,
			config: undefined as SaleConfig | undefined,
			userSaleConfig: undefined as UserSaleConfig | undefined,
			editTranslationsModal: false,
			renameModal: false,
			generalValid: false,
			electronDefaultDownloadLocation: null  as null | string,
			askNextNumberModalData: new PromisifyModal<number>()
		};
	},
	computed: {
		defaultComment(): string {
			if (!this.config)
				return "";
			return this.config.DefaultComment.getTranslation(this.locale);
		},
		locale(): string {
			return this.$i18n.locale;
		},
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales",
					value: this.$ct("sale/purchase")
				},
				{
					to: "/settings/sales/types",
					value: this.$ct("per-type")
				},
				{
					value: this.saleType ? this.saleType.getDisplayedName(this.$i18n.locale) : ""
				}
			] as IBreadCrumb[];
		},
		isValid(): boolean {
			if (!this.config) return false;
			if (!this.generalValid) return false;
			return this.config.isValid();
		},
		dropdownItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("rename-sale-type"),
					value: ()=>this.renameModal = true
				},
				{
					text: this.$ct("edit-sale-type-translations"),
					value: ()=>this.renameType(),
				},
				{
					text: this.$ct("fix-numbering"),
					value: ()=>this.fixNumbering()
				}
			];
		},
		hasCalendarModule():boolean {
			return AuthService.hasModule(MODULE.AGENDA);
		}
	},
	methods: {
		async save() {
			if (!this.saleType) return;
			if (!this.config) return;
			if (!this.userSaleConfig) return;
			if (!this.isValid) return;

			await DossierConfigService.setSaleTypeConfig(this.saleType, this.config);

			let u = UserConfigService.getSaleSettings();
			u.setSaleConfig(this.saleType,this.userSaleConfig);
			await UserConfigService.setSaleSettings(u);

			this.$wf.notify(this.$ct("saved").toString(), "success", 3000, "check");
			this.$router.push("/settings/sales/types");
			if (BrowserInfo.hasElectronConfigured()){
				ElectronFunctions.setDownloadFolderForSaleType(this.saleType.ID, this.electronDefaultDownloadLocation);
			}
		},

		async fixNumbering() {
			if (!this.saleType) return;
			let newNumber = await this.askNextNumberModalData.show();
			let confirm = await this.$wf.confirm(this.$ct("confirm-fix-numbering"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await SaleService.fixFriendlyIds(this.saleType.ID, 1, newNumber);
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
		},

		renameType(){
			this.editTranslationsModal = true;
		},
		async onNewTypeName(name:CustomTranslation){
			if (!this.saleType) return;
			let t = await SaleService.getType(this.saleType.ID);
			t.Name = name;
			this.saleType = await SaleService.updateType(t);
		},
	},
	async created() {
		this.saleType = await SaleService.getType(parseInt(this.$route.params.id));
		this.config = DossierConfigService.getSaleConfig(this.saleType);
		this.userSaleConfig = UserConfigService.getSaleSettings().getSaleConfig(this.saleType) || new UserSaleConfig();
		if (BrowserInfo.hasElectronConfigured()){
			this.electronDefaultDownloadLocation = ElectronFunctions.getDownloadFolderForSaleType(this.saleType.ID);
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppEditDefaultImportSaleRowDescriptionTemplate,
		AppEditPerDocumentStockSettings,
		AppSaleTypeEditGeneral,
		AppSaleTypeEditTexts,
		AppTranslationEditModal,
		AppSaleTypeCalendarSettings,
		AppSaleTypeCalendarHoverSettings,
		AppSaleTypeEditMailSettings,
		AppSaleTypeEditName,
		AppAskNextNumber
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
